import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class RotateAction extends AbstractProvidedClass {
    initialRotation;
    endRotation;

    constructor(provider, rotateCoordinate) {
        super(provider);

        this.rotateCoordinate = rotateCoordinate;
        this.parent = rotateCoordinate.parent;
        this.initialRotation = this.parent.rotation;
    }

    update() {
        this.rotateCoordinate.drag();
    }

    finish() {
        this.endRotation = this.parent.rotation;
        this.initialRotation == this.endRotation
            ? this.actions.discard()
            : this.actions.finish();
    }

    undo() {
        this.parent.rotation = this.initialRotation;
    }

    redo() {
        this.parent.rotation = this.endRotation;
    }
}
